import React from 'react'
import classes from './simple-select.module.scss';
const dropdownimage = require('../../assets/img/select_dropdown.svg');

const SimpleSelect = ({ options, value, onChange, children }) =>{
    return (
        <div className={classes.SimpleSelect}>
        <select value={value} onChange={onChange} style={{ backgroundImage: `url(${dropdownimage})` }}>
        { options.map((option)=>(<option key={option.value} value={option.value}>{option.label}</option>)) }
        </select>
        <span> { children }</span>
        </div>
    );
}

export { SimpleSelect } ;